module.exports = __webpack_public_path__ + "img/art_7_2.653337df.png";